import React from 'react';
import Header from '../components/Header';
import Hero from '../components/home/Hero';
import homeImage from '../assets/images/hero_bg_contact.png';
import Contact_Us from '../components/contact/contact_us';
import Footer from '../components/Footer';
import BookingConditions from "../components/how_to_book/BookingConditions";


const Contact = () => {
    return (
        <div>
            <div className='Frequently_Asked_Questions'>
                <Header />
                <Hero
                    title="How to Book"
                    backgroundImage={homeImage}
                />
                <BookingConditions />
                <Footer />
            </div>
        </div>
    );
};

export default Contact;